import { Table } from "@jasper/shared";
import {
  useExternalCasesList,
  useDentistList,
  useCreateOrder,
} from "@jasper/use-cases";
import { Modal } from "@mantine/core";
import { useState } from "react";
import { ExternalCaseDentistSelection } from "./modals/ExternalCaseDentistSelection";
import type { ExternalCase } from "../../../../../libs/use-cases/src/gql/generated/graphql";

const ExternalCaseList = () => {
  const [isModalDentistSelectionOpened, setIsModalDentistSelectionOpened] =
    useState<boolean>(false);
  const [selectedCase, setSelectedCase] = useState<ExternalCase | null>(null);

  const {
    unhandledExternalCases,
    isLoading: isUnhandledExternalCaseLoading,
    refetch: refetchExternalCaseList,
  } = useExternalCasesList();
  const { dentistList, isLoading: isDentistListLoading } = useDentistList();
  const { createOrderFromExternalCase } = useCreateOrder();

  if (isUnhandledExternalCaseLoading || isDentistListLoading) {
    return <>Loading...</>;
  }

  if (unhandledExternalCases.length === 0) {
    return <>There are no unhandled external cases</>;
  }

  return (
    <>
      <Modal
        size={"auto"}
        opened={isModalDentistSelectionOpened}
        onClose={() => setIsModalDentistSelectionOpened(false)}
      >
        <ExternalCaseDentistSelection
          selectedCase={
            selectedCase
              ? {
                  id: selectedCase.id,
                  patient: `${selectedCase?.patientFirstName ?? "-"} ${selectedCase?.patientLastName ?? "-"}`,
                  externalEmail: selectedCase.externalEmail,
                  integrationType: selectedCase.integrationType,
                }
              : null
          }
          dentistList={dentistList}
          onSubmit={async ({
            selectedCaseId,
            dentistId,
          }: {
            selectedCaseId: string;
            dentistId: string;
          }) => {
            await createOrderFromExternalCase({
              variables: {
                externalCaseId: selectedCaseId,
                dentistId: dentistId,
              },
            });
            await refetchExternalCaseList();
            setIsModalDentistSelectionOpened(false);
          }}
        />
      </Modal>
      <Table
        columns={[
          "id",
          "Case Id",
          "External Email",
          "Patient",
          "Received on",
          "Integration Type",
        ]}
        rows={unhandledExternalCases.map(externalCase => [
          externalCase.id,
          externalCase.directId,
          externalCase.externalEmail ?? "",
          `${externalCase.patientFirstName ?? ""} ${externalCase.patientLastName ?? ""}`,
          new Date(externalCase.createdAt).toLocaleDateString(),
          externalCase.integrationType,
        ])}
        eventClick={unhandledExternalCases.map(externalCase => {
          return () => {
            setSelectedCase(externalCase);
            setIsModalDentistSelectionOpened(true);
          };
        })}
      />
    </>
  );
};

export default ExternalCaseList;
